import { TOfferKind } from '../../offer/offer.types';
import { QuestionKind, QuestionOptions } from '../../question/question.types';

type Admin = {
  type: string;
  photoThumbUrl: string;
  lastName: string;
  id: number;
  firstName: string;
};

export enum RatingLevel {
  No = 'no',
  Neutral = 'neutral',
  Yes = 'yes',
  StrongYes = 'strong_yes',
}

export type InterviewResultOffer = {
  id: number;
  kind: TOfferKind;
  position: number;
  slug: string;
  status: string;
  title: string;
  type: string;
};

export type Params = {
  candidateId?: number;
  limit?: number;
  page?: number;
  scope?: string;
  adminIds?: number[] | null;
  status?: string;
};
export type InterviewResultAnswerOption = { hint: string; title: string };

export type InterviewResultAnswer = {
  content?: string;
  contents?: string[];
  id: number;
  flag?: boolean;
  questionHint: string;
  questionKind: QuestionKind;
  questionRequired: boolean;
  questionTitle: null | string;
  attachmentIds?: number[];
  attachments?: any[];
  options?: InterviewResultAnswerOption[];
  questionOptions?: QuestionOptions;
};

export type InterviewResultStage = {
  category: string;
  createdAt: string;
  id: number;
  name: string;
  position: number;
  type: string;
  updatedAt: string;
};

export type InterviewResultGuest = {
  name: string;
  photoThumbUrl: string;
  authToken: string;
  createdAt: string;
  email: string;
  id: number;
  recruiter: boolean;
  type: string;
  updatedAt: string;
};

export type InterviewResult = {
  admin: Admin;
  adminId: number;
  candidate: any;
  candidateId: number;
  createdAt: string;
  guestId: null | number;
  id: number;
  interviewResultAnswers: InterviewResultAnswer[];
  interviewResultRequestId?: number;
  interviewTemplateName: string;
  kind: string;
  offer?: InterviewResultOffer;
  offerId: number | null;
  rating: string;
  ratingNote: null | string;
  ratingRequired?: boolean;
  guest?: InterviewResultGuest;
  stage?: InterviewResultStage;
  stageId: number | string;
  updatedAt: string;
};

export type HiddenResultPreview = {
  count: number;
  admins: Admin[];
  guests?: InterviewResultGuest[];
  offer: InterviewResultOffer;
  stage: InterviewResultStage;
  offerId: number;
  stageId: number | null;
};

export type InterviewResultCollection = {
  requests: InterviewResult[];
  hiddenResultsPreview: HiddenResultPreview[];
  counters: { completed: number; dismissed: number; pending: number };
};

export type HiddenInterviewResult = InterviewResult & { hidden?: boolean };
